import React from 'react';

export default function CheckoutSteps(props) {
  return (
    <div className="row checkout-steps">
      <div className={props.step1 ? 'active' : ''}>Cart</div>
      <div className="divider"></div>
      <div className={props.step2 ? 'active' : ''}>Shipping</div>
      <div className="divider"></div>
      <div className={props.step3 ? 'active' : ''}>Payment</div>
    </div>
  );
}